import React from 'react';
export function IntroSection() {
  return <section id="about" className="bg-[#F8F6F2] py-16 md:py-24 relative" data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-88">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2" data-id="element-89">
            <div className="relative" data-id="element-90">
              <div className="absolute inset-0 bg-[#C8A84E] rounded-2xl transform translate-x-4 translate-y-4 opacity-20" data-id="element-91"></div>
              <img src="https://cdn.magicpatterns.com/uploads/syscBF98oG1btAaFkkgBqK/raise_the_bar_june_2024-110.jpg" alt="Med Spa Treatment" className="relative z-10 w-full h-auto rounded-2xl shadow-xl object-cover aspect-[4/5] md:aspect-auto" data-id="element-92" />
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center" data-id="element-93">
            <span className="text-[#C8A84E] text-sm tracking-[0.2em] uppercase font-semibold mb-4 block" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-94">
              Welcome to Raise The Bar
            </span>

            <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A] mb-6 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-95">
              Where Personalized Care Meets Advanced Aesthetics
            </h2>

            <p className="text-[#1A1A1A]/80 text-base md:text-lg mb-8 leading-relaxed" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-96">
              At Raise The Bar Med Spa, we work closely with each client to
              create a comfortable, personalized treatment journey. Using the
              latest evidence-based methods and medical-grade products, our
              licensed professionals deliver exceptional care that leaves you
              feeling refreshed, revitalized, and confident after every visit.
            </p>

            <div data-id="element-97">
              <a href="#about-more" className="inline-flex items-center text-[#C8A84E] font-semibold hover:underline underline-offset-4 transition-all min-h-[48px]" style={{
              fontFamily: "'Montserrat', sans-serif"
            }} data-id="element-98">
                Learn About Us <span className="ml-2" data-id="element-99">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[60%] h-[1px] bg-[#C8A84E]/40" data-id="element-100"></div>
    </section>;
}